"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const HBIcon_1 = __importDefault(require("../components/HBIcon/HBIcon"));
function TwoStarsPurpleSvg(props) {
    return react_1.default.createElement("svg", Object.assign({ width: 12, height: 12, viewBox: "0 0 12 12", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        react_1.default.createElement("g", { id: "Prefix" },
            react_1.default.createElement("path", { id: "Subtract", d: "M1 8.47597C2.28989 8.31262 3.31165 7.28993 3.47291 6H3.5173C3.67896 7.2932 4.70549 8.31779 6 8.47719V8.52035C4.70467 8.67984 3.67766 9.70564 3.517 11H3.47321C3.31295 9.7089 2.29071 8.68502 1 8.52157L1 8.47597Z", fill: "#131416" }),
            react_1.default.createElement("path", { id: "Subtract_2", d: "M4 3.9635C6.06751 3.70523 7.70614 2.067 7.96447 0H8.0355C8.29383 2.06701 9.93248 3.70525 12 3.9635V4.03451C9.93181 4.29284 8.29278 5.93205 8.03525 8H7.96471C7.70719 5.93206 6.06817 4.29286 4 4.03451L4 3.9635Z", fill: "#5E30E3" })));
}
function TwoStarsPurple(_a) {
    var { svgProps } = _a, props = __rest(_a, ["svgProps"]);
    return react_1.default.createElement(HBIcon_1.default, Object.assign({}, props),
        react_1.default.createElement(TwoStarsPurpleSvg, Object.assign({}, svgProps)));
}
exports.default = TwoStarsPurple;
//# sourceMappingURL=TwoStarsPurple.js.map